import { Fragment, type ReactNode } from "react";

import { Navigate } from "react-router";
import type { TUserRoles } from "../app/app.constants";
import useAuth from "../hooks/useAuth";

interface AuthGuardProps {
  children: ReactNode;
  roles?: TUserRoles[];
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { accessToken } = useAuth();

  if (!accessToken) {
    return <Navigate to="/login" />;
  }

  return <Fragment>{children}</Fragment>;
}
